export default "__VITE_ASSET__umVa41M2__"